import { translateText } from 'utils/i18n';
import { I18N_PLATFORM_COMMON_WORD_PATH } from './i18n';

export const DEFAULT_PAGE_NAME = translateText(
  `${I18N_PLATFORM_COMMON_WORD_PATH}.propertyIntelligence`,
);
